import React, { useCallback, useEffect, useState } from 'react';
import {
  Box, Button, CircularProgress, Dialog, DialogActions, DialogContent,
  DialogTitle, List, ListItem, ListItemText, Typography,
} from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';
import { lmsService } from '../../services/api';

export default function LmsVersionHistory({ entityType, entityId, onRestored, buttonLabel = 'Версії' }) {
  const [open, setOpen] = useState(false);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [restoring, setRestoring] = useState(null);

  const load = useCallback(async () => {
    if (!entityType || !entityId) return;
    setLoading(true);
    try {
      const res = await lmsService.versions(entityType, entityId);
      setRows(Array.isArray(res.data) ? res.data : []);
    } catch (e) {
      alert(e?.response?.data?.detail || e.message);
      setRows([]);
    } finally {
      setLoading(false);
    }
  }, [entityType, entityId]);

  useEffect(() => {
    if (open) load();
  }, [open, load]);

  const handleRestore = async (id) => {
    if (!window.confirm('Відновити цю версію? Поточний текст буде збережено в історії.')) return;
    setRestoring(id);
    try {
      await lmsService.versionRestore(id);
      setOpen(false);
      onRestored?.();
    } catch (e) {
      alert(e?.response?.data?.detail || e.message);
    } finally {
      setRestoring(null);
    }
  };

  if (!entityId) return null;

  return (
    <>
      <Button size="small" startIcon={<HistoryIcon />} onClick={() => setOpen(true)} variant="outlined">
        {buttonLabel}
      </Button>
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Історія версій</DialogTitle>
        <DialogContent>
          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}><CircularProgress /></Box>
          ) : rows.length === 0 ? (
            <Typography color="text.secondary">Версій ще немає.</Typography>
          ) : (
            <List dense>
              {rows.map((v) => (
                <ListItem
                  key={v.id}
                  secondaryAction={
                    <Button size="small" disabled={restoring === v.id} onClick={() => handleRestore(v.id)}>
                      {restoring === v.id ? <CircularProgress size={16} /> : 'Відновити'}
                    </Button>
                  }
                >
                  <ListItemText
                    primary={v.title || `Версія #${v.id}`}
                    secondary={`${v.editor_name || '—'} · ${v.created_at ? new Date(v.created_at).toLocaleString('uk-UA') : ''}`}
                  />
                </ListItem>
              ))}
            </List>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Закрити</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
